module.exports = __webpack_public_path__ + "img/cb-unlock.abde40a8.svg";